import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const LazyCampusIndex = React.lazy(
	() => import(/* webpackChunkName: 'StudentCampusIndex' */ './components')
);

export default () => {
	return {
		index: true,
		element: <AsyncLoading component={<LazyCampusIndex />} />,
	};
};
